module.exports = __webpack_public_path__ + "static/media/Template_38.c4654b67.png";